import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function ProcessComplete() {
  return (
    <div className="center-items">
      <CheckCircleOutlineIcon
        style={{
          transform: 'scale(3) translateY(-70%)',
          color: '#2f999d',
          marginTop: '5.5vh',
        }}
      />
      <h3
        style={{
          fontWeight: 'normal',
          fontSize: '2.7vh',
          margin: '0 0 1% 0',
        }}
      >
        Process complete!
      </h3>
      <p
        style={{
          width: '63%',
          color: '#868080',
          lineHeight: '3vh',
          textAlign: 'center',
        }}
      >
        Thank you for completing your booking, you will receive a DPD tracking number when your order is complete. You
        can track your order on the following <a href="https://tracking.dpd.ie/">link</a>
      </p>
    </div>
  );
}

export default ProcessComplete;
